import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import { CollectionToDtoMap } from '@/shared/lib/sj-orm/types';

// TODO rework
export const isColDto = <T extends keyof CollectionToDtoMap>(
  col: T,
  data: { id: DtoId },
): data is CollectionToDtoMap[T] => {
  return data.id.startsWith(col);
};
